import subjectCore from '@/api/subject-core'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return subjectCore.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return subjectCore.store(
      Object.assign({}, data, {
        acp_id: parseInt(data.acp_id),
        acps_id: parseInt(data.acps_id),
        subject_order: parseInt(data.subject_order),
        display_column: parseInt(data.display_column)
      })
    )
  },
  update(context, { subject_id, ...data }) {
    return subjectCore.update(
      subject_id,
      Object.assign({}, data, {
        acp_id: parseInt(data.acp_id),
        acps_id: parseInt(data.acps_id),
        subject_order: parseInt(data.subject_order),
        display_column: parseInt(data.display_column)
      })
    )
  },
  destroy(context, id) {
    return subjectCore.destroy(id)
  },
  removeComponent(context, id) {
    return subjectCore.removeComponent(id)
  },
  removeComponentItems(context, id) {
    return subjectCore.removeComponentItems(id)
  }
}
